import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToDo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.7778C14.2955 17.7778 17.7778 14.2955 17.7778 10C17.7778 5.70445 14.2955 2.22222 10 2.22222C5.70445 2.22222 2.22222 5.70445 2.22222 10C2.22222 14.2955 5.70445 17.7778 10 17.7778ZM10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToDo);

export default ForwardRef;
